import { getYouTubeEmbedUrl } from "../lib/coachUtils";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
} from "./ui/dialog";
import { useLanguage } from "../contexts/LanguageContext";

// Anteprima in-app del video di un esercizio (sola lettura, nessuna modifica).
// Stessa regola della modale di modifica: se il video non è embeddabile, YouTube
// mostra il proprio messaggio nel player.
export function ExerciseVideoDialog({
	videoUrl,
	exerciseName,
	open,
	onOpenChange,
}) {
	const { t } = useLanguage();
	const embedUrl = getYouTubeEmbedUrl(videoUrl);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="bg-card border-border w-[calc(100vw-2rem)] max-w-2xl">
				<DialogDescription className="hidden" />
				<DialogHeader>
					<DialogTitle className="font-heading">
						{exerciseName || t("videoPreview")}
					</DialogTitle>
				</DialogHeader>
				{embedUrl && (
					<div className="aspect-video rounded-sm overflow-hidden">
						<iframe
							src={embedUrl}
							title={exerciseName || t("videoPreview")}
							className="w-full h-full"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
						/>
					</div>
				)}
			</DialogContent>
		</Dialog>
	);
}
